<template>
    <section class="checkin hero is-fullheight" :class="{ 'is-success': response.reward }">
        <input type="text" class="hidden-input" autofocus v-model="input" ref="cardno" @blur.prevent="refocus" />

        <div class="hero-body" v-if="response.reward">
            <div class="container has-text-centered reward">
                <h1 class="title is-1" v-html="humanStatus"></h1>
                <p>Du har checket ind {{ this.rewardCheckinCount }} og har derfor fået en belønning!</p>
                <img v-if="response.reward.image" :src="response.reward.image" class="reward-image" />
                <div class="products">
                    <h2
                        class="title is-2"
                        v-for="product in response.reward.products"
                        v-text="product.count + ' x ' + product.title"
                    ></h2>
                </div>
            </div>
        </div>

        <div class="hero-foot" v-if="response.reward">
            <div class="container has-text-centered">
                <p>Henvend dig i receptionen for at indløse din belønning. Produktet er blevet tilskrevet din konto!</p>
            </div>
        </div>

        <div class="hero-body" v-if="!response.reward">
            <img :src="data.logo" class="logo" />

            <div class="container has-text-centered">
                <template v-if="!processing && !response.status">
                    <h1 class="title is-1">Indlæs medlemskort</h1>
                </template>
                <template v-else-if="processing & !response.status">
                    <div class="loading"><span class="spinner"></span></div>
                </template>
                <template v-else>
                    <h1 class="title is-1" v-html="humanStatus"></h1>
                    <h4
                        class="title is-4 checkin-count"
                        v-html="checkinCount"
                        v-if="response.status == 'ok' || response.status == 'bookings'"
                    ></h4>
                    <div
                        class="notification is-success"
                        v-text="response.quote"
                        v-if="(response.status == 'ok' || response.status == 'bookings') && response.quote"
                    ></div>
                </template>
            </div>

            <span class="clock" v-text="clock"></span>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: { type: Object, required: true },
    },

    data() {
        return {
            processing: false,
            input: '',
            clock: '',
            clockInterval: null,
            response: {},
            responseTimeout: null,
        }
    },

    watch: {
        input: function(newVal) {
            if (newVal.length == 0) {
                return
            }
            this.submitCheckin()
        },
        response: function(newVal) {
            if (!newVal) {
                return
            }

            clearInterval(this.responseTimeout)

            this.responseTimeout = setTimeout(
                () => {
                    this.response = {}
                },
                this.response.status == 'reward' || this.response.status == 'bookings' ? 12000 : 8000
            )
        },
    },

    computed: {
        humanStatus() {
            if (!this.response) {
                return ''
            }
            switch (this.response.status) {
                case 'checkin_throttling_exception':
                    return 'Du er allerede checket ind.<br/><br/>God træning!'
                    break
                case 'checkin_subscription_paused_exception':
                    return 'Dit abonnement er i bero, og du kan derfor ikke checke ind. <br/><br/><span class="emphasis">Kontakt receptionen.</span>'
                    break
                case 'checkin_no_subscription_exception':
                    return 'Du har ikke noget aktivt abonnement, og kan derfor ikke checke ind. <br/><br/><span class="emphasis">Kontakt receptionen.</span>'
                    break
                case 'customer_not_found':
                    return 'Der blev ikke fundet en kunde på det scannede kort. <br/><br/><span class="emphasis">Kontakt receptionen.</span>'
                    break
                case 'ok':
                case 'bookings':
                    return 'God træning ' + this.response.name + '!'
                    break
                case 'error':
                    return 'Der er sket en fejl under indcheckning. <br/><br/><span class="emphasis">Prøv igen.</span>'
                    break
                case 'reward':
                    return 'Woohoo!'
                    break
            }
        },
        checkinCount() {
            if (this.response.bookings) {
                return '<span class="emphasis-green">Du er fremmødt til ' + this.response.bookings + '</span>'
            }

            return 'Det er din ' + this.response.count + ' træning i denne måned.'
        },
        rewardCheckinCount() {
            if (!this.response.reward) {
                return ''
            }

            switch (this.response.reward.checkin_period) {
                case 'month':
                    return (
                        this.response.reward.checkin_count +
                        ' gang' +
                        (this.response.reward.checkin_count > 1 ? 'e' : '') +
                        ' denne måned'
                    )
                    break
                case 'quarter':
                    return (
                        this.response.reward.checkin_count +
                        ' gang' +
                        (this.response.reward.checkin_count > 1 ? 'e' : '') +
                        ' dette kvartal'
                    )
                    break
                case 'year':
                    return (
                        this.response.reward.checkin_count +
                        ' gang' +
                        (this.response.reward.checkin_count > 1 ? 'e' : '') +
                        ' i år'
                    )
                    break
            }
        },
    },
    mounted() {
        this.updateClock()
        this.refocus()

        this.clockInterval = setInterval(() => {
            this.updateClock()
        }, 1000)

        setTimeout(() => {
            window.location.reload(true)
        }, 900000)
    },
    destroyed() {
        clearInterval(this.clockInterval)
    },
    methods: {
        refocus() {
            setTimeout(() => {
                this.$refs.cardno.focus()
            }, 50)
        },

        submitCheckin: _.debounce(function() {
            if (this.processing) {
                return
            }

            this.response = {}
            this.processing = true

            /* Checkin codes are 9 or 10 digits, so no reason to submit if the length is different */
            if (this.input.length >= 7 && this.input.length <= 12) {
                this.$http
                    .post('/checkin', {
                        card: this.input,
                        center: this.data.center,
                    })
                    .then(response => {
                        this.response = response.data
                    })
                    .catch(error => {
                        this.response.status = 'error'
                        setTimeout(() => {
                            //location.reload(true);
                        }, 3000)
                    })
                    .then(() => {
                        this.processing = false
                        this.input = ''
                        this.refocus()
                    })
            } else {
                this.processing = false
                this.input = ''
            }
        }, 500),
        padZero(number) {
            if (number < 10) {
                return '0' + number
            }
            return number
        },
        updateClock() {
            let date = new Date()
            this.clock =
                this.padZero(date.getHours()) +
                ':' +
                this.padZero(date.getMinutes()) +
                ':' +
                this.padZero(date.getSeconds())
        },
    },
}
</script>

<style lang="scss">
@import '../../../sass/admin/variables';

.checkin {
    .logo {
        max-width: 40vh;
        max-height: 20vh;
        position: absolute;
        top: 15vh;
        left: 50%;
        transform: translateX(-50%);
    }

    .title {
        text-transform: uppercase;
        font-weight: 400;

        .emphasis {
            color: red;
            font-weight: bold;
            animation: wobble 5s infinite;
        }

        .emphasis-green {
            color: darkgreen;
            font-weight: bold;
            font-size: 36px;
            margin-top: 50px;
        }
    }

    .loading {
        position: relative;
        display: block;
        margin: 3rem auto;

        .spinner {
            -webkit-animation: spinAround 500ms infinite linear;
            animation: spinAround 500ms infinite linear;
            border: 8px solid #dbdbdb;
            border-radius: 290486px;
            border-right-color: transparent;
            border-top-color: transparent;
            content: '';
            display: block;
            height: 3rem;
            position: relative;
            width: 3rem;
            left: 50%;
            margin-left: -1.5rem;
            margin-top: -1.5rem;
            position: absolute;
            top: 50%;
            border-color: transparent transparent rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0.5) !important;
        }
    }

    .clock {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        text-align: right;
        padding: 0.5rem 1rem;
        background-color: #28a990;
        background-image: linear-gradient(141deg, #16885f, #28a990 71%, #27c3bf);
        color: #fff;
        font-weight: bold;
    }

    .reward {
        p {
            font-size: 2rem;
            &:last-child {
                margin-top: 2rem;
            }
        }

        .reward-image {
            background: #fff;
            padding: 2rem;
            display: block;
            margin: 3rem auto;
            max-width: 40vh;
            max-height: 30vh;
            border-radius: 5px;
            -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
            box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
        }
    }

    .hero-foot p {
        font-size: 2rem;
        margin-bottom: 2rem;
    }

    .notification.is-success {
        background-color: #28a990;
        background-image: linear-gradient(141deg, #16885f, #28a990 71%, #27c3bf);
        color: #fff;
        margin-top: 3rem;
        font-size: 1.5rem;
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    }

    .hidden-input {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }
}
</style>
